import Update from '@/classes/updates/Update'

export default class Updates extends Array {
  constructor (updates, ...rest) {
    Array.isArray(updates) ? super(...updates.map(update => new Update(update))) : super(...rest)
  }
}
